export default __webpack_public_path__ + "static/media/Category_Automotive_135x195.0bedd7d4.jpg";